import { useEffect } from 'react';
import { withVueRouter, connectVuex } from 'vuereact-combined';
const AuthenticatedApp = ({ $vueRouter, vuexCommit, data = {}, isTestingEnv }) => {
    var _a;
    const { sessionId, firstName, lastName, username, licenses, gradeLevel, id, settings } = data;
    const path = isTestingEnv && ((_a = $vueRouter === null || $vueRouter === void 0 ? void 0 : $vueRouter.history) === null || _a === void 0 ? void 0 : _a._startLocation) === '/tester'
        ? 'tester'
        : 'curriculum';
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f;
        vuexCommit('student/setStudent', {
            accessibilitySettings: {
                audioSettings: Object.assign({ muteSounds: false, volume: 100 }, ((_b = (_a = settings === null || settings === void 0 ? void 0 : settings.accessibility) === null || _a === void 0 ? void 0 : _a.audioSettings) !== null && _b !== void 0 ? _b : {})),
                closedCaptionsSettings: Object.assign({ closedCaptionSize: 22, showClosedCaptions: false }, ((_d = (_c = settings === null || settings === void 0 ? void 0 : settings.accessibility) === null || _c === void 0 ? void 0 : _c.closedCaptionsSettings) !== null && _d !== void 0 ? _d : {})),
                videoNarrationSettings: {
                    showSettings: (_e = settings === null || settings === void 0 ? void 0 : settings.accessibility) === null || _e === void 0 ? void 0 : _e.videoNarrationSettings.showSettings
                }
            },
            firstName,
            grade: gradeLevel,
            id,
            lastName,
            licenses: licenses,
            oneHandedTypingHand: (_f = settings === null || settings === void 0 ? void 0 : settings.oneHandedTypingHand) !== null && _f !== void 0 ? _f : '',
            sessionId,
            successfullyLoggedIn: true,
            username
        }, { root: true });
        $vueRouter.push({ path }).catch(failure => {
            console.log({ failure });
            '';
        });
    }, []);
    return null;
};
export default connectVuex({
    mapCommitToProps(commit) {
        return {
            vuexCommit: commit
        };
    }
})(withVueRouter(AuthenticatedApp));
